export var ValidationStrategyEnum;
(function (ValidationStrategyEnum) {
    ValidationStrategyEnum["VALIDATE_MISSING_PAYLOAD_VALUES_FOR_HYDRATION"] = "VALIDATE_MISSING_PAYLOAD_VALUES_FOR_HYDRATION";
    ValidationStrategyEnum["VALIDATE_MISSING_CONTROL_VALUES"] = "VALIDATE_MISSING_CONTROL_VALUES";
})(ValidationStrategyEnum || (ValidationStrategyEnum = {}));
